import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { totalBonuses, totalVolumes } from '../data/offer';
export function GuaranteeSection() {
  return <section className="bg-amber-50 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-110" data-mp="9ttgc9z21wy4">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-111" data-mp="et67v80vfs71">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border-2 border-stone-200 bg-white p-8 shadow-sm sm:p-12" data-id="element-112" data-mp="euqwyi4f2ixi">
          <span className="inline-flex rounded-full bg-green-900 p-4 text-amber-400" data-id="element-113" data-mp="sn6ux4ignqrk">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-114" data-mp="xj5tfkxi6p5p" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-green-950" data-id="element-115" data-mp="12kl8mwd021g6">
            Complete 7-day guarantee
          </h2>
          <p className="mt-4 leading-relaxed text-stone-600" data-id="element-116" data-mp="25rnjh0sl8ott">
            Open all {totalVolumes} volumes. Review all {totalBonuses} bonuses. Use them in your most challenging drilling
            and well engineering class this week. If you feel your students didn't respond better or the materials didn't save you hours of
            work:
          </p>
          <p className="mt-6 rounded-lg bg-green-50 px-5 py-4 text-lg font-extrabold text-green-950" data-id="element-117" data-mp="1rtywnneyn7m4">
            We refund 100% of your money. No questions. No forms. No complications.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-stone-600" data-id="element-118" data-mp="2jk3p89cvj0yf">
            Because if this teacher ready doesn't deliver the value we promise, we don't want to keep your money.
          </p>
        </motion.div>
      </div>
    </section>;
}